class StrateProduit {
  private formattedImagesList: any[] = [];
  private formattedBulletsList: any[] = [];

  private imagesList: NodeListOf<any> = document.querySelectorAll(
    '.strate-produit__card-img'
  );
  private bulletsList: NodeListOf<any> = document.querySelectorAll(
    '.strate-produit__colors-bullet'
  );

  private categoriesWrappers: NodeListOf<HTMLElement> =
    document.querySelectorAll('.strate-produit__content');

  constructor() {
    if (this.imagesList.length > 0 && this.bulletsList.length > 0) {
      this.formatImagesByIndexes();
      this.formatBulletsByIndexes();
      this._init();
    }
    if (this.categoriesWrappers.length > 0) {
      this.initCategoriesListeners();
    }
  }

  private formatImagesByIndexes(): void {
    this.categoriesWrappers.forEach((content, i) => {
      const imagesList = content.querySelectorAll('.strate-produit__card-img');
      Array.from(imagesList).forEach((img) => {
        const image = img?.getAttribute('data-img-index')?.split('-');
        if (image) {
          const [categoryIndex, parentIndex, index] = image;

          if (this.formattedImagesList[i] === undefined) {
            this.formattedImagesList[i] = [];
          }
          if (this.formattedImagesList[i][categoryIndex] === undefined) {
            this.formattedImagesList[i][categoryIndex] = [];
          }
          if (
            this.formattedImagesList[i][categoryIndex][parentIndex] ===
            undefined
          ) {
            this.formattedImagesList[i][categoryIndex][parentIndex] = [];
          }
          if (
            this.formattedImagesList[i][categoryIndex][parentIndex][index] ===
            undefined
          ) {
            this.formattedImagesList[i][categoryIndex][parentIndex][index] = [];
          }
          this.formattedImagesList[i][categoryIndex][parentIndex][index] = img;
        }
      });
    });
  }

  private formatBulletsByIndexes(): void {
    this.categoriesWrappers.forEach((content, i) => {
      const bulletsList = content.querySelectorAll(
        '.strate-produit__colors-bullet'
      );
      Array.from(bulletsList).forEach((bullet) => {
        const currentBullet = bullet
          ?.getAttribute('data-color-index')
          ?.split('-');
        if (currentBullet) {
          const [categoryIndex, parentIndex, index] = currentBullet;
          if (this.formattedBulletsList[i] === undefined) {
            this.formattedBulletsList[i] = [];
          }
          if (this.formattedBulletsList[i][categoryIndex] === undefined) {
            this.formattedBulletsList[i][categoryIndex] = [];
          }
          if (
            this.formattedBulletsList[i][categoryIndex][parentIndex] ===
            undefined
          ) {
            this.formattedBulletsList[i][categoryIndex][parentIndex] = [];
          }
          if (
            this.formattedBulletsList[i][categoryIndex][parentIndex][index] ===
            undefined
          ) {
            this.formattedBulletsList[i][categoryIndex][parentIndex][index] =
              [];
          }
          this.formattedBulletsList[i][categoryIndex][parentIndex][index] =
            bullet;
        }
      });
    });
  }

  private _init(): void {
    this.categoriesWrappers.forEach((content, contentIndex) => {
      const bulletsList = content.querySelectorAll(
        '.strate-produit__colors-bullet'
      );

      bulletsList.forEach((bullet: Element, bulletIndex: number) => {
        bullet.addEventListener('mouseover', (elt: any) => {
          const [categoryIndex, parentIndex, index] = elt.target
            .getAttribute('data-color-index')
            .split('-');
          this.hideImages(categoryIndex, parentIndex, contentIndex);
          if (index == 99999) {
            const video = document.querySelector('video');
            video ? (video.currentTime = 0) : null;
          }
          this.formattedImagesList[contentIndex][categoryIndex][parentIndex][
            index
          ].style.display = 'block';
          this.removeActiveBullet(categoryIndex, parentIndex, contentIndex);
          this.setCurrentBulletActive(
            categoryIndex,
            parentIndex,
            contentIndex,
            index
          );
        });
      });
    });
  }

  private hideImages(
    categoryIndex: string,
    parentIndex: string,
    contentIndex: number
  ): void {
    const filteredImages = this.getCurrentImages(
      categoryIndex,
      parentIndex,
      contentIndex
    );
    filteredImages.forEach((img) => (img.style.display = 'none'));
  }

  private getCurrentImages(
    categoryIndex: string,
    parentIndex: string,
    contentIndex: number
  ): any[] {
    const imagesList = Array.from(
      Array.from(this.categoriesWrappers)[contentIndex]?.querySelectorAll(
        '.strate-produit__card-img'
      )
    );

    return imagesList.filter((img) => {
      const imgCategoryIndex = img
        ?.getAttribute('data-img-index')
        ?.split('-')[0];
      const imgParentIndex = img?.getAttribute('data-img-index')?.split('-')[1];
      return (
        imgParentIndex &&
        imgParentIndex === parentIndex &&
        imgCategoryIndex &&
        imgCategoryIndex === categoryIndex
      );
    });
  }

  private initCategoriesListeners(): void {
    this.categoriesWrappers.forEach((container, index) => {
      const categoriesCtaList = container.querySelectorAll(
        '.strate-produit__cat-cta'
      );
      categoriesCtaList.forEach((cta, i) => {
        cta.addEventListener('mouseover', (e: any) => {
          const productsContainers = Array.from(
            container.querySelectorAll('.strate-produit__products-container')
          );
          const index = e.target.getAttribute('cat-index');
          this.hideProductsContainers(productsContainers);
          const products = productsContainers.filter((elt) => {
            return elt.getAttribute('data-index') === index;
          });
          if (products.length > 0) {
            products[0]['style'].display = 'block';
          }
          this.removeActiveCategory(categoriesCtaList);
          this.setCurrentCategoryActive(categoriesCtaList, index);
        });
      });
    });
  }

  private hideProductsContainers(productsContainers): void {
    productsContainers.forEach((elt) => {
      elt.style.display = 'none';
    });
  }
  private setCurrentCategoryActive(categoriesCtaList, index: number): void {
    categoriesCtaList[index - 1].classList.add('active');
  }

  private removeActiveCategory(categoriesCtaList): void {
    categoriesCtaList.forEach((cat) => cat.classList.remove('active'));
  }

  private setCurrentBulletActive(
    categoryIndex: number,
    parentIndex: number,
    contentIndex: number,
    index: number
  ): void {
    this.formattedBulletsList[contentIndex][categoryIndex][parentIndex][
      index
    ].classList.add('bullet-active');
  }

  private removeActiveBullet(
    categoryIndex: number,
    parentIndex: number,
    bulletIndex: number
  ): void {
    this.formattedBulletsList[bulletIndex][categoryIndex][parentIndex].forEach(
      (cat) => cat.classList.remove('bullet-active')
    );
  }
}

export const strateProduit = new StrateProduit();
